export const subCollectionList = [
  { value: 'A00051' },
  { value: 'A00052' },
  { value: 'A00053' },
  { value: 'A00054' },
  { value: 'A00055' },
]
